import React, { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

interface JustificationDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  failureModeJustification?: string;
  controlMeasureJustification?: string;
}

const JustificationDialog: FC<JustificationDialogProps> = ({
  open,
  onClose,
  title = "Justification",
  failureModeJustification,
  controlMeasureJustification,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h6">{title}</Typography>
        <IconButton aria-label="Close" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {!!failureModeJustification && (
          <>
            <Typography style={{ fontSize: 14, fontWeight: 700, marginBottom: 8 }}>
              Failure Mode wide Justification
            </Typography>
            <Typography style={{ fontSize: 14, whiteSpace: "pre-line", marginBottom: 16 }}>
              {failureModeJustification}
            </Typography>
          </>
        )}

        <Typography style={{ fontSize: 14, fontWeight: 700, marginBottom: 8 }}>
          Control Measure Justification
        </Typography>
        <Typography style={{ fontSize: 14, whiteSpace: "pre-line" }}>
          {controlMeasureJustification || "(No justification provided)"}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default JustificationDialog;